const styles = {
  modal: {
    position: 'relative',
    content: {
      padding: 0
    }
  },
  closeIcon: {
    position: 'absolute',
    top: 20,
    right: 20,
    zIndex: 2,
    cursor: 'pointer'
  }
}

export default styles
